module.exports = __webpack_public_path__ + "static/media/i6.f8478e8f.jpg";